import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4791ba6e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "c-image"
};
const _hoisted_2 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "c-image-img",
    src: $props.src,
    style: _normalizeStyle({
      objectFit: $props.fit,
      backgroundImage: `url(${$props.src})`
    })
  }, null, 12, _hoisted_2)]);
}